import ActionTypes from '../constants/ActionTypes';

const createUserRoleAssignment = (userRoleAssignment) => ({
  type: ActionTypes.USER_ROLE_ASSIGNMENT_CREATE,
  payload: {
    userRoleAssignment,
  },
});

createUserRoleAssignment.success = (localId, userRoleAssignment) => ({
  type: ActionTypes.USER_ROLE_ASSIGNMENT_CREATE__SUCCESS,
  payload: {
    localId,
    userRoleAssignment,
  },
});

createUserRoleAssignment.failure = (localId, error) => ({
  type: ActionTypes.USER_ROLE_ASSIGNMENT_CREATE__FAILURE,
  payload: {
    localId,
    error,
  },
});

const handleUserRoleAssignmentCreate = (userRoleAssignment, users) => ({
  type: ActionTypes.USER_ROLE_ASSIGNMENT_CREATE_HANDLE,
  payload: {
    userRoleAssignment,
    users,
  },
});

// Servait pour recharger les boards qui se seraient ajouter à un utilisateur en cours, mais on ne prend pas pour le moment
// handleUserRoleAssignmentCreate.fetchProject = (id, currentUserId, currentBoardId) => ({
//   type: ActionTypes.USER_ROLE_ASSIGNMENT_CREATE_HANDLE__PROJECT_FETCH,
//   payload: {
//     id,
//     currentUserId,
//     currentBoardId,
//   },
// });

const updateUserRoleAssignment = (id, data) => ({
  type: ActionTypes.USER_ROLE_ASSIGNMENT_UPDATE,
  payload: {
    id,
    data,
  },
});

updateUserRoleAssignment.success = (userRoleAssignment) => ({
  type: ActionTypes.USER_ROLE_ASSIGNMENT_UPDATE__SUCCESS,
  payload: {
    userRoleAssignment,
  },
});

updateUserRoleAssignment.failure = (id, error) => ({
  type: ActionTypes.USER_ROLE_ASSIGNMENT_UPDATE__FAILURE,
  payload: {
    id,
    error,
  },
});

const handleUserRoleAssignmentUpdate = (userRoleAssignment) => ({
  type: ActionTypes.USER_ROLE_ASSIGNMENT_UPDATE_HANDLE,
  payload: {
    userRoleAssignment,
  },
});

const deleteUserRoleAssignment = (id) => ({
  type: ActionTypes.USER_ROLE_ASSIGNMENT_DELETE,
  payload: {
    id,
  },
});

deleteUserRoleAssignment.success = (userRoleAssignment) => ({
  type: ActionTypes.USER_ROLE_ASSIGNMENT_DELETE__SUCCESS,
  payload: {
    userRoleAssignment,
  },
});

deleteUserRoleAssignment.failure = (id, error) => ({
  type: ActionTypes.USER_ROLE_ASSIGNMENT_DELETE__FAILURE,
  payload: {
    id,
    error,
  },
});

const handleUserRoleAssignmentDelete = (userRoleAssignment) => ({
  type: ActionTypes.USER_ROLE_ASSIGNMENT_DELETE_HANDLE,
  payload: {
    userRoleAssignment,
  },
});

export default {
  createUserRoleAssignment,
  handleUserRoleAssignmentCreate,
  updateUserRoleAssignment,
  handleUserRoleAssignmentUpdate,
  deleteUserRoleAssignment,
  handleUserRoleAssignmentDelete,
};
